import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationResponseJSON } from '@simplewebauthn/typescript-types';

@Injectable({
  providedIn: 'root',
})
export class PasskeysService {
  constructor(private http: HttpClient) {}

  getCredentials(url: string, user: string) {
    return this.http.get(
      `${url}/options-auth/${user}:users/${user}:current/generation`
    );
  }

  validateLogin(
    url: string,
    auth: AuthenticationResponseJSON,
    challenge: string,
    user: string
  ) {
    return this.http.post<any>(
      `${url}/auth/${user}:users/${user}:current/verification`,
      {
        challenge,
        auth,
      }
    );
  }
}
